// Module
var code = `<template> <div class="loading \${isLine ? 'line':'circle'}"></div> </template> `;
// Exports
module.exports = code;